import { withSvgIcon } from './withSvgIcon';

export const ShieldUnsafe = withSvgIcon(
  <>
    <circle cx="11.9998" cy="15.4734" r="1.19995" fill="currentColor" />
    <path
      d="M10.8474 7.32882C10.8328 7.15391 10.9708 7.00391 11.1464 7.00391H12.8742C13.0497 7.00391 13.1878 7.15391 13.1732 7.32882L12.7232 12.7288C12.7102 12.8843 12.5803 13.0039 12.4242 13.0039H11.5964C11.4403 13.0039 11.3103 12.8843 11.2974 12.7288L10.8474 7.32882Z"
      fill="currentColor"
    />
    <path
      d="M3 6L12 2L21 6C21 6 21 19 12.0001 22C2.99993 19 3 6 3 6Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
